var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCartIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 700 700",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m610.6 236.3c-1.4-21-18.9-37.7-40.3-37.7h-65.1v-71.4c0-58.4-47.5-105.8-105.8-105.8-18.3 0-35.5 4.3-50.8 12.1-15.1-7.9-31.8-12.1-49-12.1-31.1 0-60.8 18.6-83.5 52.5-18.7 27.7-29.8 61.7-29.8 90.9v33.9h-57.7c-21.3 0-38.9 16.7-40.3 37.7l-59.7 402.3-.3 2.1v2.1c0 22.2 18.1 40.3 40.3 40.3h561.7c22.2 0 40.3-18.1 40.3-40.3v-2.1zm-211.2-158.2c27.1 0 49.2 22 49.2 49.2v71.4h-105.9v-63.9c0-31.2 25.5-56.7 56.7-56.7zm-156.5 86.7c0-17.8 7.9-41 20.2-59.2 11.6-17.2 25.2-27.4 36.5-27.4h1.6c-9.7 16.7-15.2 36-15.2 56.6v63.9h-43.1zm-155.2 461.8 55.1-371.2h143.2v75.6c0 15.7 12.7 28.3 28.3 28.3s28.3-12.7 28.3-28.3v-75.6h105.8v75.6c0 15.7 12.7 28.3 28.3 28.3s28.3-12.7 28.3-28.3v-75.6h50.8l55.1 371.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m535.9 504.6h-377.5c-15.7 0-28.3 12.7-28.3 28.3s12.7 28.3 28.3 28.3h377.5c15.7 0 28.3-12.7 28.3-28.3s-12.6-28.3-28.3-28.3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCartIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cart-icon.2ae68e1612668f343176ed3179831bf0.svg";